import {
  GET_MOVEMENT_REPORTS,
  GET_LOCATION_REPORTS,
  GET_MISSING_PICTURE_REPORTS,
  GET_EXPIRED_CARD_REPORTS,
  GET_NOT_CHECKEDIN_ONBOARD_REPORTS,
  GET_CHECKEDIN_NOT_ONBOARD_REPORTS,
  GET_VISITOR_ONBOARD_REPORTS,
  GET_IPM_REPORTS,
  GET_SAILOR_HISTORY_LOCATION_REPORTS,
  GET_VISITOR_HISTORY_LOCATION_REPORTS,
  GET_CREW_HISTORY_LOCATION_REPORTS,
  GET_CBP_REPORTS_GUESTS,
  GET_CBP_REPORTS_CREW,
  GET_WEARABLE_ASSIGNED_REPORTS,
  GET_RESERVATIONS_MISSING_IN_FIDELIO_REPORTS,
  GET_ALERTS_REPORTS,
  GET_DEBARKED_ONBOARDED_SUMMARY_REPORTS,
  GET_BOARDING_SLOT_HISTORY_REPORTS,
  GET_INACTIVE_VISITOR_REPORTS,
  GET_BOARDING_SLOT_REPORTS,
  GET_SAILOR_FLIGHT_DETAILS_REPORTS,
  GET_DOCUMENT_TYPE_BREAKDOWN_REPORTS,
  GET_DOCUMENT_WISE_SAILORS,
  GET_SAILOR_NATIONALITY_REPORTS,
  GET_NATIONALITY_WISE_SAILORS
} from './../constants/actionTypes'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

const movementReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_MOVEMENT_REPORTS: {
      const page = get(action, 'data.pageInfo', {})
      const reportItems =
        isEmpty(page) || page.page === 0
          ? get(action, 'data.personMovements', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.personMovements', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const inActiveVisitorReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_INACTIVE_VISITOR_REPORTS: {
      const page = get(action, 'data.page', {})
      const reportItems =
        isEmpty(page) || page.page === 1
          ? get(action, 'data.inActiveVisitors', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.inActiveVisitors', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const sailorFlightDetailsReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_SAILOR_FLIGHT_DETAILS_REPORTS: {
      const page = get(action, 'data.pageInfo', {})
      const reportItems =
        isEmpty(page) || page.page === 1
          ? get(action, 'data.guestFlightDetails', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.guestFlightDetails', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const sailorBoardingSlotHistoryReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_BOARDING_SLOT_HISTORY_REPORTS: {
      const page = get(action, 'data.pageInfo', {})
      const reportItems =
        isEmpty(page) || page.page === 0
          ? get(action, 'data.boardingSlotHistory', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.boardingSlotHistory', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const sailorLocationHistoryReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_SAILOR_HISTORY_LOCATION_REPORTS: {
      const page = get(action, 'data.pageInfo', {})
      const reportItems =
        isEmpty(page) || page.page === 0
          ? get(action, 'data.personLocationMovements', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.personLocationMovements', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}
const visitorLocationHistoryReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_VISITOR_HISTORY_LOCATION_REPORTS: {
      const page = get(action, 'data.data.page', {})
      const reportItems =
        isEmpty(page) || page.number === 0
          ? get(action, 'data.data._embedded.locationMovement', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.data._embedded.locationMovement', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}
const crewLocationHistoryReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_CREW_HISTORY_LOCATION_REPORTS: {
      const page = get(action, 'data.data.page', {})
      const reportItems =
        isEmpty(page) || page.number === 0
          ? get(action, 'data.data._embedded.locationMovement', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.data._embedded.locationMovement', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const missingPictureReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_MISSING_PICTURE_REPORTS: {
      return exceptionReportresult(action, store)
    }
    default:
      return store
  }
}
const alertReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_ALERTS_REPORTS: {
      const page = get(action, 'data.data.page', {})
      const reportItems =
        isEmpty(page) || page.number === 0
          ? get(action, 'data.data._embedded.passengers', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.data._embedded.passengers', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const reservationsMissingInFidelioReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_RESERVATIONS_MISSING_IN_FIDELIO_REPORTS: {
      return exceptionReportresult(action, store)
    }
    default:
      return store
  }
}

const expiredCardReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_EXPIRED_CARD_REPORTS: {
      const page = get(action, 'data.data.page', {})
      const reportItems =
        isEmpty(page) || page.number === 1
          ? get(action, 'data.data._embedded.exceptions', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'ddata.data._embedded.exceptions', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const checkedInNotOnboardReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_CHECKEDIN_NOT_ONBOARD_REPORTS: {
      return exceptionReportresult(action, store)
    }
    default:
      return store
  }
}

const notCheckedInOnboardReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_NOT_CHECKEDIN_ONBOARD_REPORTS: {
      return exceptionReportresult(action, store)
    }
    default:
      return store
  }
}

const visitorOnboardReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_VISITOR_ONBOARD_REPORTS: {
      const page = get(action, 'data.data.page', {})
      const reportItems =
        isEmpty(page) || page.number === 1
          ? get(action, 'data.data._embedded.exceptions', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.data._embedded.exceptions', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const wearableAssignedReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_WEARABLE_ASSIGNED_REPORTS: {
      return {
        reportItems: action.data.data
      }
    }
    default:
      return store
  }
}

const documentTypeBreakdownReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_DOCUMENT_TYPE_BREAKDOWN_REPORTS: {
      const page = get(action, 'data.pageInfo', {})
      const reportItems =
        isEmpty(page) || page.page === 1
          ? get(action, 'data.guestDocumentTypeReport', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.guestDocumentTypeReport', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const documentWiseSailors = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_DOCUMENT_WISE_SAILORS: {
      const page = get(action, 'data.pageInfo', {})
      const reportItems =
        isEmpty(page) || page.page === 1
          ? get(action, 'data.documentWiseGuests', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.documentWiseGuests', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const sailorNationalityReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_SAILOR_NATIONALITY_REPORTS: {
      const page = get(action, 'data.pageInfo', {})
      const reportItems =
        isEmpty(page) || page.page === 1
          ? get(action, 'data.guestNationalityReport', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.guestNationalityReport', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const nationalityWiseSailors = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_NATIONALITY_WISE_SAILORS: {
      const page = get(action, 'data.pageInfo', {})
      const reportItems =
        isEmpty(page) || page.page === 1
          ? get(action, 'data.nationalityWiseGuests', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.nationalityWiseGuests', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const locationReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_LOCATION_REPORTS: {
      const page = get(action, 'data.data.page', {})
      const reportItems =
        isEmpty(page) || page.number === 0
          ? get(action, 'data.data._embedded.locations', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.data._embedded.locations', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const debarkedOnboardedSummaryReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_DEBARKED_ONBOARDED_SUMMARY_REPORTS: {
      const page = get(action, 'data.pageInfo', {})
      const reportItems =
        isEmpty(page) || page.page === 1
          ? get(action, 'data.debarkedOnboardedSummary', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.debarkedOnboardedSummary', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const boardingSlotReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_BOARDING_SLOT_REPORTS: {
      const page = get(action, 'data.data.boardingSlotReport.pageInfo', {})
      const dynamicBoardingSlots =
        isEmpty(page) || page.page === 1
          ? get(action, 'data.data.boardingSlotReport.boardingSlotList', [])
          : get(store, 'dynamicBoardingSlots', [])
      const reportItems =
        isEmpty(page) || page.page === 1
          ? get(action, 'data.data.boardingSlotReport.voyages', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.data.boardingSlotReport.voyages', [])
            ]
      return {
        page,
        dynamicBoardingSlots,
        reportItems
      }
    }
    default:
      return store
  }
}

const cbpReportsGuests = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_CBP_REPORTS_GUESTS: {
      const page = get(action, 'data.pageInfo', {})
      const cbpSummary = get(
        action,
        'data.cbpDetailInformation[0].cbpSummary',
        {}
      )
      const reportItems =
        isEmpty(page) || page.page === 0
          ? get(action, 'data.cbpDetailInformation[0].cbpSummaryDetail', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(
                action,
                'data.cbpDetailInformation[0].cbpSummaryDetail',
                []
              )
            ]
      return {
        page,
        reportItems,
        cbpSummary
      }
    }
    default:
      return store
  }
}

const cbpReportsCrew = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_CBP_REPORTS_CREW: {
      const page = get(action, 'data.pageInfo', {})
      const cbpSummary = get(
        action,
        'data.cbpDetailInformation[0].cbpSummary',
        {}
      )
      const reportItems =
        isEmpty(page) || page.page === 0
          ? get(action, 'data.cbpDetailInformation[0].cbpSummaryDetail', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(
                action,
                'data.cbpDetailInformation[0].cbpSummaryDetail',
                []
              )
            ]
      return {
        page,
        reportItems,
        cbpSummary
      }
    }
    default:
      return store
  }
}

const ipmReports = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_IPM_REPORTS: {
      const page = get(action, 'data.pageInfo', {})
      const reportItems =
        isEmpty(page) || page.page === 0
          ? get(action, 'data.inPortMannings', [])
          : [
              ...get(store, 'reportItems', []),
              ...get(action, 'data.inPortMannings', [])
            ]
      return {
        page,
        reportItems
      }
    }
    default:
      return store
  }
}

const exceptionReportresult = (action, store) => {
  const page = get(action, 'data.pageInfo', {})
  const reportItems =
    isEmpty(page) || page.page === 1
      ? get(action, 'data.personExceptions', [])
      : [
          ...get(store, 'reportItems', []),
          ...get(action, 'data.personExceptions', [])
        ]
  return {
    page,
    reportItems
  }
}

export {
  movementReports,
  missingPictureReports,
  expiredCardReports,
  checkedInNotOnboardReports,
  notCheckedInOnboardReports,
  visitorOnboardReports,
  wearableAssignedReports,
  debarkedOnboardedSummaryReports,
  boardingSlotReports,
  reservationsMissingInFidelioReports,
  locationReports,
  cbpReportsGuests,
  cbpReportsCrew,
  sailorLocationHistoryReports,
  sailorBoardingSlotHistoryReports,
  sailorFlightDetailsReports,
  crewLocationHistoryReports,
  visitorLocationHistoryReports,
  ipmReports,
  alertReports,
  inActiveVisitorReports,
  documentTypeBreakdownReports,
  documentWiseSailors,
  sailorNationalityReports,
  nationalityWiseSailors
}
